import { presetMap } from "./presets.js";
function getPreset(presetId = "modal") {
  if (!presetMap[presetId]) {
    console.warn(`unknown preset: '${presetId}'`);
    return {
      view: "inline"
    };
  }
  return presetMap[presetId];
}
function getPresetId(presetId) {
  if (!presetMap[presetId]) {
    console.warn(`unknown presetId: '${presetId}'`);
    return "inline";
  }
  return presetId;
}
function isInlinePreset(presetId) {
  return getPreset(presetId).view === "inline";
}
function isModalViewForbiddenPath() {
  if (typeof window === "undefined") {
    return false;
  }
  const modalViewforbiddenPaths = ["/account-login", "/account-register", "/invite"];
  let currentPath = window.location.pathname;
  const languagePrefixPattern = /^\/[a-z]{2}(?:-[A-Z]{2})?\//;
  currentPath = currentPath.replace(languagePrefixPattern, "/");
  return modalViewforbiddenPaths.some((path) => currentPath === path);
}
export {
  getPreset,
  getPresetId,
  isInlinePreset,
  isModalViewForbiddenPath
};
//# sourceMappingURL=preset-utils.js.map
